import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { regex } from '@capsovision/capso_utils';
import Request from '../../components/AxiosInstance';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';


export default function SetUsernamePassword() {

	const navigate = useNavigate();
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	}

	const formikForm = useFormik({
		initialValues: {
			username: '',
			password: '',
			rptPassword: ''
		},
		validationSchema: yup.object({
			username: yup.string().required('Username is required').min(6, 'Username must be at least 6 characters').max(40, 'Username must be at most 40 characters'),
			password: yup.string().required('Password is required').matches(regex.password, 'Your password must contain at least eight characters, at least one number and both lower and uppercase letters'),
			rptPassword: yup.string().oneOf([yup.ref('password')], 'Passwords must match')
		}),
		onSubmit: async (values) => {
			formSubmit(values)
		},
	});

	const formSubmit = async (formValue) => {
		try {
			await Request.post('/api/account/sup', formValue);
			toast.success('Username and password successfully set');
			navigate('/acc');
		} catch (e) {
			console.error(e)
		}
	}

	return (
		<Container component="main" maxWidth="xs">
			<Typography variant="h5" gutterBottom>Set Username & Password</Typography>
			<Typography variant="subtitle2">You may login with username and password after setup</Typography>
			<Box sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
			}}>
				<Box component="form" onSubmit={(e) => {
					e.preventDefault();
					formikForm.handleSubmit();
				}} sx={{
					mt: 1,
					maxWidth: "sm"
				}}>
					<TextField
						margin="normal"
						required
						fullWidth
						id="username"
						label="Username"
						name="username"
						autoComplete="username"
						value={formikForm.values.username}
						onChange={formikForm.handleChange}
						error={formikForm.touched.username && Boolean(formikForm.errors.username)}
						helperText={formikForm.touched.username && formikForm.errors.username}
					/>
					<TextField
						margin="normal"
						required
						fullWidth
						name="password"
						label="Password"
						type={showPassword ? 'text' : 'password'}
						id="password"
						autoComplete="new-password"
						value={formikForm.values.password}
						onChange={formikForm.handleChange}
						error={formikForm.touched.password && Boolean(formikForm.errors.password)}
						helperText={formikForm.touched.password && formikForm.errors.password}
						InputProps={{
							endAdornment: <InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									onClick={handleClickShowPassword}
								>
									{showPassword ? <VisibilityOff /> : <Visibility />}
								</IconButton>
							</InputAdornment>
						}}
					/>
					<TextField
						margin="normal"
						required
						fullWidth
						name="rptPassword"
						label="Repeat Password"
						type={showPassword ? 'text' : 'password'}
						id="rptPassword"
						autoComplete="new-password"
						value={formikForm.values.rptPassword}
						onChange={formikForm.handleChange}
						error={formikForm.touched.rptPassword && Boolean(formikForm.errors.rptPassword)}
						helperText={formikForm.touched.rptPassword && formikForm.errors.rptPassword}
						InputProps={{
							endAdornment: <InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									onClick={handleClickShowPassword}
								>
									{showPassword ? <VisibilityOff /> : <Visibility />}
								</IconButton>
							</InputAdornment>
						}}
					/>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						sx={{ mt: 3, mb: 2 }}
					>
						Submit
					</Button>
				</Box>
			</Box>
		</Container>
	)
}